// @flow
import * as React from 'react';
import type {CountryDisplayName} from 'docs/components/core/CountryName/CountryName';
import Box from 'sail/Box';
import {Subheading, SubheadingTextProps} from 'sail/Text';

import {AlignBox} from 'sail/Align';
import Select, {SelectOption} from 'sail/Select';

type BusinessStructureSelectorProps = {|
  countries: Array<CountryDisplayName>,
|};

export const BusinessStructureSelector = ({
  countries,
}: BusinessStructureSelectorProps) => {
  const [country, setCountry] = React.useState('US');

  React.useEffect(() => {
    document.querySelectorAll('.BusinessStructureDoc').forEach((elem) => {
      elem.style.display = 'none';
    });

    const targetClassName = `business-structure--${country}`;

    // iterate over extra documents, match any subset of target classes.
    document.querySelectorAll(`.BusinessStructureDoc`).forEach((elem) => {
      const classSet = new Set(
        [...elem.classList].filter((k) => k.startsWith('business-structure')),
      );

      if (classSet.has(targetClassName)) {
        elem.style.display = 'block';
      }
    });
  });

  return (
    <label>
      <Box
        divider={{color: 'light', width: 1, side: 'bottom'}}
        style={{height: '52px', marginLeft: '1px'}} // 1px margin so divider is not cut-off in a section
        flex={{alignItems: 'center'}}
      >
        <AlignBox reference={SubheadingTextProps}>
          <Box padding={{right: 12}}>
            <Subheading>Country:</Subheading>
          </Box>
          <Select onChange={setCountry} value={country}>
            {countries.map(({name, code}) => (
              <SelectOption key={code} label={name || code} value={code} />
            ))}
          </Select>
        </AlignBox>
      </Box>
    </label>
  );
};
